/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Org_Settings_Characters_CountInputs */



/**
* | output |
* | --- |
* | "{count}/{max} characters" |
*
* @param {Org_Settings_Characters_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_settings_characters_count = /** @type {((inputs: Org_Settings_Characters_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Settings_Characters_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}/${i?.max} Zeichen`)
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max} characters`)
});